module.exports = __webpack_public_path__ + "img/air@2x.e050aa21.png";